/// <amd-module name="Build/Run/Components/ArtifactsLink" />
import * as React from "react";

import { ArtifactsData, RunDetailsData } from "Build/Client/Contracts/DataProvider";
import { IBuildLinkingService } from "Build/Client/Linking";
import { NavConstants } from "Build/Common/Library/Constants";
import * as Resources from "Build/Run/Resources";

import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { localeFormat } from "VSS/Core/Util/String";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";

const c_TelemetrySource = "RunSummary";
const c_RunViewArtifacts = "RunViewArtifacts";

interface IArtifactsLinkProps {
    artifactsData: IReadonlyObservableValue<ArtifactsData>;
    run: RunDetailsData
    linkDescribedBy?: string;
}

export class ArtifactsLink extends VssComponent<IArtifactsLinkProps> {
    constructor(props: IArtifactsLinkProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return (
            <Observer artifacts={this.props.artifactsData}>
                { (observerProps: {artifacts: ArtifactsData}) => this.renderLink(observerProps.artifacts) }
            </Observer>
        );
    };

    private getLinkUrl = (): string => {
        const linkService = this.context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService"); 
        return linkService.getBuildUrl(this.props.run.id,
            NavConstants.artifacts,
            undefined,
            undefined,
            {['pathAsName']: "false"}
        );
    }

    private renderLink = (artifacts: ArtifactsData): JSX.Element => {
        if (artifacts && (artifacts.publishedArtifactsCount > 0 || artifacts.consumedArtifactsCount > 0)) {
            const url = this.getLinkUrl();
            let text: string = "";

            if (artifacts.publishedArtifactsCount > 0 && artifacts.consumedArtifactsCount > 0) {
                text = localeFormat(Resources.ArtifactsFormat, artifacts.publishedArtifactsCount, artifacts.consumedArtifactsCount);
            }
            else if (artifacts.publishedArtifactsCount > 0) {
                text = localeFormat(Resources.ArtifactsPublishedFormat, artifacts.publishedArtifactsCount);
            }
            else {
                text = localeFormat(Resources.ArtifactsConsumedFormat, artifacts.consumedArtifactsCount);
            }

            const className = "flex-row flex-baseline primary-text";
            return (
                <FPSLink
                    ariaDescribedBy={this.props.linkDescribedBy}
                    className={className}
                    href={url}
                    subtle={true}
                    telemetrySource={c_TelemetrySource}
                    telemetryProperties={{clickedOn: c_RunViewArtifacts}}
                    removeUnderline={true}
                >
                    <Icon iconName="Package" className="pipelines-icon-right-margin" />
                    <span style= {{whiteSpace : 'nowrap'}}> {text} </span>
                </FPSLink>
            );
        }

        return (
            <span className="text-ellipsis secondary-text summary-line-non-link">
                <Icon iconName="Package" className="pipelines-icon-right-margin" />
                {localeFormat(Resources.ArtifactsCount, "0")}
            </span>
        );
    }
}